import { Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription, timer } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from 'src/app/classes';
import { modules } from 'src/app/globals';
import { QuillNoteTypeMismatchDialogComponent } from 'src/app/lib/shared/components/dialog/quill-note-type-mismatch-dialog/quill-note-type-mismatch-dialog.component';
import { DOUBLET_PROVIDER_SERVICE, IDoubletProviderService } from 'src/app/lib/shared/interfaces';
import { ContractService } from '../../../services/contract.service';

@Component({
  selector: 'app-contract-form',
  templateUrl: './contract-form.component.html',
  styleUrls: ['./contract-form.component.css']
})
export class ContractFormComponent implements OnDestroy, OnInit {

  @Input() editMode: boolean = true;
  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';
  @Input() showIdGenerator: boolean = true;

  formGroup: FormGroup;

  modules = modules;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Optional() @Inject(DOUBLET_PROVIDER_SERVICE) public doubletService: IDoubletProviderService,
    private _controlContainer: ControlContainer,
    private _dialog: MatDialog,
    private _contractService: ContractService,
    private _snackBar: MatSnackBar
  ) { }

  clearDescription(){
    this.contractdescControl.setValue(null);
    this.contractdescControl.markAsDirty();
  }

  generateContractNumber(){
    this._contractService.generateContractNumber().subscribe(
      (contractNumber: number) => this.formGroup.controls['contractnumber'].setValue(contractNumber),
      (error: HttpErrorResponse) => this._snackBar.open('Fehler beim generieren der Vertragsnummer', 'Ok')
    );
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    if (this.doubletService) this._subscriptions.push(this.contractdescControl.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
      this.doubletService.setSearchString(value);
    }));

    this._subscriptions.push(...[
      this.contractnoteControl.valueChanges.pipe(take(1), takeUntil(timer(2000))).subscribe((note: string) => {
        if(typeof note !== 'string') return;
        if (note.startsWith('{"ops":[{')) {
          this._dialog.open(QuillNoteTypeMismatchDialogComponent, {
            panelClass: 'no-padding-dialog-container',
            data: note
          }).afterClosed().subscribe((htmlResult: string) => {
            if (htmlResult) {
              this.contractnoteControl.setValue(htmlResult);
              this.contractnoteControl.markAsDirty();
            }
          });
        }
      })
    ])
  }

  get contractdescControl(): AbstractControl {
    return this.formGroup.controls['contractdesc'];
  }
  get contractnoteControl(): AbstractControl {
    return this.formGroup.controls['contractnote'];
  }

}
